import React, { PureComponent, ReactElement } from "react";
import {
  SettingsPanelContainerRow,
  SettingsPanelContainerColumn,
  ModalContainer,
  ModalBackdrop,
  VerticalFlex,
  SettingsSpan,
  ErrorElem,
  styledScrollBars,
  FlexItem50,
} from "../common/StyledComponents";
import { connect } from "react-redux";
import styled from "styled-components/macro";
import Select from "react-select";
import Draggable from "react-draggable";
import sortBy from "lodash/sortBy";
import { workflowStatesSelector } from "../../../rematch/selectors/selectors";
import {
  BUTTON_BACKGROUND_COLOR,
  SIDELIST_TITLE_BACKGROUND,
  TASK_HEIGHT_COMPACT,
  TASK_HEIGHT_LOOSE,
  EDITBOX_BORDER,
  ITEM_DEFAULT_COLOR
} from "../../helpers/Const";
import { GenericButton, SecondaryButton, IconSettingsButton50x50 } from "../common/Buttons";

import { withTranslation, WithTranslation } from "react-i18next";

import viewSettingsIcon from "../../../icons/ButtonViewSettings.png";
import viewSettingsIconHover from "../../../icons/ButtonViewSettingsHover.png";
import viewSettingsIconPressed from "../../../icons/ButtonViewSettingsPressed.png";
import DisplaySettingDefaults from "../../../rematch/defaults/DisplaySettingDefaults";
import { TableColumnEditor, ITableColumn } from "./TableColumnEditor";

import { getLongDayNames, formatWithLocale as format } from "../../helpers/DateHelpers";
import { translateObjectTypeName, translatePropertyDefName } from "src/backend/helpers/translationHelpers";
import { BuiltInPropertyDef } from "src/backend/constants/builtinProperties";
import { DisplaySettings, GridColumns } from "src/rematch/interfaces/states/IViewSettingsState";
import { iRootState, Dispatch } from "src/rematch/store";
import { IObjectTypeConfigurationItem, IWorkflowState, IOwnPropertyOrId } from "src/backend/interfaces/configuration/IConfiguration";
import IMFilesPropertyDefinition from "src/backend/interfaces/mfiles/IMFilesPropertyDefinition";
import { Action } from "@rematch/core";

const SETTINGS_MODAL_WIDTH = 1100;

const DRAG_HANDLE_CLASSNAME = "dragHandle";

const DragHandle = styled.div.attrs(() => ({
  className: DRAG_HANDLE_CLASSNAME,
}))`
  margin-top: -24px;
  cursor: move;
  width: 100%;
  height: 100%;
`;

const DisplaySettingsOuterContainer = styled.div`
  border: 2px solid ${EDITBOX_BORDER};
  background: white;
  padding: 24px;
  color: ${SIDELIST_TITLE_BACKGROUND};

  display: flex;
  flex-direction: column;
  width: ${SETTINGS_MODAL_WIDTH}px;
`;

const SettingsHeader = styled.div`
  font-size: 18px;
  text-transform: uppercase;
  padding-bottom: 8px;
`;

const SettingsSubHeading = styled.div`
  text-transform: uppercase;
  font-weight: bold;
`;

const SettingsRow = styled.div`
  flex: 0 0 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface IDisplaySettingsTabProps {
  isSelected?: boolean;
}

const DisplaySettingsTab = styled.div`
  background: ${(props: IDisplaySettingsTabProps) => props.isSelected ? EDITBOX_BORDER : BUTTON_BACKGROUND_COLOR};
  bottom: ${(props: IDisplaySettingsTabProps) => props.isSelected ? 0 : 2}px;
  flex: 1 0 auto;
  overflow: hidden;
  position: relative;

  text-transform: uppercase;
  color: white;
  font-weight: bold;
  cursor: pointer;

  display: flex;
  align-items: center;
  padding-left: 28px;
  height: 39px;
  margin-left: 2px;
  &:first-child {
    margin-left: 0;
  }
`;

const DisplaySettingsInnerContainer = styled(DisplaySettingsOuterContainer)`
  flex-direction: row;
  width: 100%;
`;

interface IDisplaySettingsInnerContainerScrollProps {
  maxHeight: number;
}

const DisplaySettingsInnerContainerScroll = styled(DisplaySettingsInnerContainer)`
  max-height: ${(props: IDisplaySettingsInnerContainerScrollProps) => props.maxHeight}px;
  overflow-y: auto;
  ${styledScrollBars}
`;

const FlexItem = styled.div`
  flex: 0 1 auto;
  display: flex;
`;

const imgs = [viewSettingsIcon, viewSettingsIconHover, viewSettingsIconPressed];

interface ISelectColorProps {
  color?: string;
}

export const SelectColor = styled.div`
  background: ${(props: ISelectColorProps) => props.color};
  height: 22px;
  width: 44px;
  flex: 0 0 44px;
  margin: auto;
`;

interface ISelectItem {
  value: string;
}

export const colorSelectElem = (data: ISelectItem): ReactElement => <SelectColor color={data.value} />;

export const selectStyles = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  container: (styles: any) => {
    return {
      ...styles,
      flex: "0 0 auto",
      height: "30px",
    };
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  valueContainer: (styles: any) => {
    return {
      ...styles,
      width: "52px",
      padding: "2px 4px",
    };
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  dropdownIndicator: (styles: any) => {
    return {
      ...styles,
      padding: "3px",
    };
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  control: (styles: any) => {
    return {
      ...styles,
      minHeight: "30px",
    };
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  option: (styles: any) => {
    return {
      ...styles,
      padding: "4px",
    };
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  menu: (styles: any) => {
    return {
      ...styles,
      marginTop: 0,
    };
  },
};

interface IDisplaySettingsEditorProps extends WithTranslation {
  displaySettings: DisplaySettings;
  objectTypeConfigurations: IObjectTypeConfigurationItem[];
  getPropertyDefinition: (propertyId: number) => IMFilesPropertyDefinition;
  getObjectTypeProperties: (objectTypeId: number) => number[];
  getWorkflowStates: () => IWorkflowState[];
  setDisplaySettings: (settings: DisplaySettings) => Action<DisplaySettings,void>;
  updateTextFields: () => Action<void,void>;
}

interface IDisplaySettingsEditorState {
  showDisplaySettings: boolean;
  unappliedChanges: DisplaySettings;
  openTabIndex: number;
  error: string;
}

class DisplaySettingsEditor extends PureComponent<IDisplaySettingsEditorProps,IDisplaySettingsEditorState> {
  dragRef: React.RefObject<HTMLDivElement>;
  constructor(props: IDisplaySettingsEditorProps) {
    super(props);
    this.dragRef = React.createRef();
    this.state = {
      showDisplaySettings: false,
      unappliedChanges: { ...this.props.displaySettings, gridColumns: this.initializeGridColumns() },
      openTabIndex: 0,
      error: null,
    };
  }

  componentDidMount = () => {
    for (const imgURL of imgs) {
      const img = new Image();
      img.src = imgURL;
    }
  };

  apply = () => {
    const error = this.validateSettings(this.state.unappliedChanges);
    if (error) {
      this.setState({ error: error });
      return;
    }
    this.toggleSettingsVisibility();
    this.props.setDisplaySettings(this.state.unappliedChanges);
    this.props.updateTextFields();
  };

  cancel = () => {
    this.setState(() => {
      return {
        unappliedChanges: { ...this.props.displaySettings, gridColumns: this.initializeGridColumns() },
        showDisplaySettings: false,
      };
    });
  };

  setDefaults = () => {
    this.setState(() => {
      return {
        unappliedChanges: { ...DisplaySettingDefaults, gridColumns: this.initializeGridColumns(true), stateInfo: this.initializeStateInfo() },
      };
    });
  };

  initializeStateInfo = () => {
    const workflowStates = this.props.getWorkflowStates();
    const defaultStateInfo = workflowStates.reduce((acc, workflowState, i) => {
      const color = i < DisplaySettingDefaults?.colorOptions?.length ? DisplaySettingDefaults.colorOptions?.[i] : ITEM_DEFAULT_COLOR;
      acc[workflowState.ID] = { name: `${workflowState.WorkflowName}: ${workflowState.Name}`, color: color };
      return acc;
    }, {});
    return { ...defaultStateInfo };
  };

  handleColorChange = (statusIndex: string, newColor: string) => {
    this.setState((prevState) => {
      const newState = { unappliedChanges: { ...prevState.unappliedChanges, stateInfo: { ...prevState.unappliedChanges.stateInfo } } };
      newState.unappliedChanges.stateInfo[statusIndex].color = newColor;
      return newState;
    });
  };

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (this.state.error) {
      this.setState({ error: null });
    }
    const fieldName = event.target.name;
    let value;
    if (event.target.type === "checkbox") {
      value = event.target.checked;
    } else {
      value = parseInt(event.target.value); // There is no need for any strings so far.
    }    
    this.setState(() => {
      return { unappliedChanges: { ...this.state.unappliedChanges, [fieldName]: value } };
    });
  };

  handleInputSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const inputEvent = event as React.ChangeEvent<HTMLElement> as React.ChangeEvent<HTMLInputElement>;
    this.handleInputChange(inputEvent);
  }

  handleStringChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (this.state.error) {
      this.setState({ error: null });
    }
    const fieldName = event.target.name;
    const value = event.target.value;
    this.setState(() => {
      return { unappliedChanges: { ...this.state.unappliedChanges, [fieldName]: value } };
    });
  }

  handleStringSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const inputEvent = event as React.ChangeEvent<HTMLElement> as React.ChangeEvent<HTMLInputElement>;
    this.handleStringChange(inputEvent);
  }

  toggleSettingsVisibility = () => {
    this.setState((prevState) => {
      return {
        showDisplaySettings: !prevState.showDisplaySettings,
        unappliedChanges: {...this.props.displaySettings, gridColumns: this.initializeGridColumns()},
      };
    });
  };

  validateSettings = (_settings) => {
    return null;
  };

  referenceDateTime = () => {
    return new Date("2021-01-31T16:30:22");
  }

  renderDateFormats = () => {
    const dateFormats = [
      "P",
      "PP",
      "yyyy-MM-dd",
      "dd.MM.yyyy",
      "dd/MM/yyyy",
      "MM/dd/yyyy",
    ];
    const dateFormatItems = [];
    const dateNow = this.referenceDateTime();
    for(const dateFormat of dateFormats) {
      const dateStar = dateFormat.substring(0,1) === "P" ? "*" : "";
      dateFormatItems.push(<option key={dateFormat} value={dateFormat}>{format(dateNow, dateFormat) + dateStar}</option>);
    }
    return dateFormatItems;
  }

  renderTimeFormats = () => {
    const dateFormats = [
      "p",
      "HH:mm",
      "HH.mm",
      "h.mm a"
    ];
    const dateFormatItems = [];
    const dateNow =  this.referenceDateTime();
    for(const dateFormat of dateFormats) {
      const dateStar = dateFormat.substring(0,1) === "p" ? "*" : "";
      dateFormatItems.push(<option key={dateFormat} value={dateFormat}>{format(dateNow, dateFormat) + dateStar}</option>);
    }
    return dateFormatItems;
  }

  renderWeekDayList = () => {
    const weekdays = getLongDayNames();
    const options = [];
    for(let weekday = 0; weekday < 7; weekday++) {
      options.push(<option key={weekday} value={weekday}>{weekdays[weekday]}</option>);
    }
    return options;
  }

  renderGeneralProperties = () => {
    const { t } = this.props;
    return (
      <DisplaySettingsInnerContainerScroll maxHeight={window.innerHeight - 260}>
        <VerticalFlex style={{ justifyContent: "flex-start", alignItems: "flex-start", flex: 1 }}>
          <SettingsRow>
            <SettingsSubHeading>{t("displaysettings.generalsettings")}</SettingsSubHeading>
          </SettingsRow>
          <SettingsRow style={{ marginTop: 10 }}>{t("displaysettings.timelinelayout")}</SettingsRow>
          <SettingsRow>
            <input
              type="radio"
              checked={this.state.unappliedChanges.taskHeight === TASK_HEIGHT_LOOSE}
              name="taskHeight"
              id="layoutLoose"
              value={TASK_HEIGHT_LOOSE}
              onChange={this.handleInputChange}
            ></input>
            <label htmlFor="layoutLoose">{t("displaysettings.layoutloose").toString()}</label>
          </SettingsRow>
          <SettingsRow>
            <input
              type="radio"
              checked={this.state.unappliedChanges.taskHeight === TASK_HEIGHT_COMPACT}
              name="taskHeight"
              id="layoutCompact"
              value={TASK_HEIGHT_COMPACT}
              onChange={this.handleInputChange}
            ></input>
            <label htmlFor="layoutCompact">{t("displaysettings.layoutcompact").toString()}</label>
          </SettingsRow>
          <SettingsRow style={{ marginTop: 10 }}>{t("displaysettings.notificationmessagetimeout")}</SettingsRow>
          <SettingsRow>
            <input
              type="number"
              name="notificationMessageTimeout"
              id="settingsNotificationMessageTimeout"
              value={this.state.unappliedChanges.notificationMessageTimeout}
              onChange={this.handleInputChange}
              step="1"
              min="0"
              max="60"
            ></input>
          </SettingsRow>
          <SettingsRow style={{ marginTop: 10 }}>{t("displaysettings.refreshinterval")}</SettingsRow>
          <SettingsRow>
            <input
              type="number"
              name="refreshInterval"
              id="settingsRefreshInterval"
              value={this.state.unappliedChanges.refreshInterval}
              onChange={this.handleInputChange}
              step="1"
              min="0"
              max="240"
            ></input>
          </SettingsRow>
          <SettingsRow style={{ marginTop: 10 }}>
            <input
              type="checkbox"
              checked={this.state.unappliedChanges.allowAddAndEdit}
              name="allowAddAndEdit"
              id="settingsAllowAddAndEdit"
              onChange={this.handleInputChange}
            ></input>
            <label htmlFor="settingsAllowAddAndEdit">{t("displaysettings.allowaddandedit").toString()}</label>
          </SettingsRow>
        </VerticalFlex>
        <VerticalFlex style={{ justifyContent: "flex-start", alignItems: "flex-start", flex: 1 }}>
          <SettingsSubHeading>{t("displaysettings.datesettings")}</SettingsSubHeading>
          <SettingsRow>{t("displaysettings.firstdayofweek")}</SettingsRow>
          <SettingsRow>
            <select name="startOfWeekDay" value={this.state.unappliedChanges.startOfWeekDay} onChange={this.handleInputSelectChange}>
              {this.renderWeekDayList()}
            </select>
          </SettingsRow>
          <SettingsRow>{t("displaysettings.dateformat")}</SettingsRow>
          <SettingsRow>
            <select name="dateFormat" value={this.state.unappliedChanges.dateFormat} onChange={this.handleStringSelectChange}>
              {this.renderDateFormats()}
            </select>
            <select name="timeFormat" value={this.state.unappliedChanges.timeFormat} onChange={this.handleStringSelectChange}>
              {this.renderTimeFormats()}
            </select>
          </SettingsRow>
          <SettingsRow>
            <input
              type="checkbox"
              checked={this.state.unappliedChanges.showTimeInTable}
              name="showTimeInTable"
              id="settingsShowTimeInTable"
              onChange={this.handleInputChange}
            ></input>
            <label htmlFor="settingsShowTimeInTable">{t("displaysettings.showtimeintable").toString()}</label>
          </SettingsRow>
          <SettingsRow>{t("displaysettings.intimeline")}</SettingsRow>
          <SettingsRow>
            <input
              type="checkbox"
              checked={this.state.unappliedChanges.showCurrentDay}
              name="showCurrentDay"
              id="settingsShowCurrentDay"
              onChange={this.handleInputChange}
            ></input>
            <label htmlFor="settingsShowCurrentDay">{t("displaysettings.showcurrentday").toString()}</label>
          </SettingsRow>
          <SettingsRow>
            <input
              type="checkbox"
              checked={this.state.unappliedChanges.showHolidays}
              name="showHolidays"
              id="settingsShowHolidays"
              onChange={this.handleInputChange}
            ></input>
            <label htmlFor="settingsShowHolidays">{t("displaysettings.showholidays").toString()}</label>
          </SettingsRow>
          <SettingsRow>
            <input
              type="checkbox"
              checked={this.state.unappliedChanges.fullPrint}
              name="fullPrint"
              id="settingsPrintFullTimeline"
              onChange={this.handleInputChange}
            ></input>
            <label htmlFor="settingsPrintFullTimeline">{t("displaysettings.printfulltimeline").toString()}</label>
          </SettingsRow>
          <SettingsRow>
            <input
              type="checkbox"
              checked={this.state.unappliedChanges.adjustForWeekendAndHolidays}
              name="adjustForWeekendAndHolidays"
              id="settingsAdjustForWeekendAndHolidays"
              onChange={this.handleInputChange}
            ></input>
            <label htmlFor="settingsAdjustForWeekendAndHolidays">{t("displaysettings.adjustweekendandholidays").toString()}</label>
          </SettingsRow>
        </VerticalFlex>
      </DisplaySettingsInnerContainerScroll>
    );
  };

  renderColorSelect = (stateSelectOptions: ISelectItem[]) => {
    const elements = [];
    for (const [stateId, {name, color}] of Object.entries(this.props.displaySettings.stateInfo)) {
      elements.push(
        <SettingsRow key={stateId} style={{ width: "70%" }}>
          {`${name}`}
          <Select
            key={stateId}
            value={stateSelectOptions.filter((option) => option.value === color)}
            isSearchable={false}
            options={stateSelectOptions}
            onChange={(e) => {
              this.handleColorChange(stateId, e.value);
            }}
            formatOptionLabel={colorSelectElem}
            styles={selectStyles}
          ></Select>
        </SettingsRow>
      );
    }
    return elements;
  };

  renderLabelsAndColors = () => {
    const { t } = this.props;
    const stateSelectOptions: ISelectItem[] = [];
    for (const colorOption of this.props.displaySettings.colorOptions) {
      stateSelectOptions.push({
        value: colorOption,
      });
    }

    return (
      <DisplaySettingsInnerContainerScroll maxHeight={window.innerHeight - 260}>
        <VerticalFlex style={{ justifyContent: "flex-start", alignItems: "flex-start", flex: 1 }}>
          <SettingsSubHeading>{t("displaysettings.statuscolors")}</SettingsSubHeading>
          {this.renderColorSelect(stateSelectOptions)}
        </VerticalFlex>
        <VerticalFlex style={{ justifyContent: "flex-start", alignItems: "flex-start", flex: 1 }}></VerticalFlex>
      </DisplaySettingsInnerContainerScroll>
    );
  };

  updateColumns = (objectType: number, columns: IOwnPropertyOrId[]) => {
    this.setState(() => {
      return { unappliedChanges: { ...this.state.unappliedChanges, gridColumns: { ...this.state.unappliedChanges.gridColumns, [objectType]: columns } } };
    });
  };

  initializeGridColumns = (ignoreUserSettings = false): GridColumns => {
    const allGridColumns: GridColumns = {};
    for(const objectTypeConfiguration of this.props.objectTypeConfigurations) {
      let typeGridColumns = objectTypeConfiguration.gridColumns;
      if(!ignoreUserSettings && this.props.displaySettings.gridColumns) {
        const userGridColumns = this.props.displaySettings.gridColumns[objectTypeConfiguration.objectTypeId];
        if(userGridColumns) {
          typeGridColumns = userGridColumns;
        }
      }
      allGridColumns[objectTypeConfiguration.objectTypeId] = typeGridColumns;
    }
    return allGridColumns;
  }

  renderColumns = () => {
    const { t } = this.props;
    const elements = [];
    for(const objectTypeConfiguration of this.props.objectTypeConfigurations) {
      const selectedColumns: IOwnPropertyOrId[] = this.state.unappliedChanges.gridColumns[objectTypeConfiguration.objectTypeId];
      const objectTypeColumns: ITableColumn[] = [];
      for(const propertyId of this.props.getObjectTypeProperties(objectTypeConfiguration.objectTypeId)) {
        const propertyDef = this.props.getPropertyDefinition(propertyId);
        const propertyName = translatePropertyDefName(propertyDef.ID, propertyDef.Name);
        objectTypeColumns.push({
          value: propertyDef.ID,
          label: propertyName
        });
      }
      const ownColumns: ITableColumn[] = [
        { value: "name", label: t("property.name") },
        { value: "start", label: t("property.start") },
        { value: "end", label: t("property.end") },
        { value: BuiltInPropertyDef.State, label: t("property.status") }, // Use builtin state instead of status
      ];
      const availableColumns = ownColumns.concat(sortBy(objectTypeColumns, c => c.label));
      elements.push(
        <TableColumnEditor
          key={objectTypeConfiguration.objectTypeId} 
          objectTypeId={objectTypeConfiguration.objectTypeId} 
          name={translateObjectTypeName(objectTypeConfiguration.objectTypeId,objectTypeConfiguration.name)}
          selectedColumns={selectedColumns}
          availableColumns={availableColumns}
          updateColumns={this.updateColumns}
        />
      );
    }

    return (
      <DisplaySettingsInnerContainerScroll maxHeight={window.innerHeight - 260}>
        <VerticalFlex style={{ justifyContent: "flex-start", alignItems: "flex-start", flex: 1 }}>
          {elements}
        </VerticalFlex>
        <VerticalFlex style={{ justifyContent: "flex-start", alignItems: "flex-start", flex: 1 }}></VerticalFlex>
      </DisplaySettingsInnerContainerScroll>
    );
  }

  renderOpenTab = () => {
    if (this.state.openTabIndex === 0) {
      return this.renderGeneralProperties();
    } else if(this.state.openTabIndex === 1) {
      return this.renderColumns();
    } else {
      return this.renderLabelsAndColors();
    }
  };

  renderDisplaySettings = () => {
    const { t } = this.props;
    return (
      <div>
        <Draggable nodeRef={this.dragRef} handle={`.${DRAG_HANDLE_CLASSNAME}`}>
          <ModalContainer ref={this.dragRef} style={{ left: "50%", marginLeft: -SETTINGS_MODAL_WIDTH / 2 }}>
            <DisplaySettingsOuterContainer>
              <DragHandle>&nbsp;</DragHandle>
              <FlexItem>
                <SettingsHeader>{t("displaysettings.title")}</SettingsHeader>
              </FlexItem>
              <FlexItem>
                <DisplaySettingsTab isSelected={this.state.openTabIndex === 0} onClick={(_e) => this.setState({ openTabIndex: 0 })}>
                  {t("displaysettings.generaltabtext")}
                </DisplaySettingsTab>
                <DisplaySettingsTab isSelected={this.state.openTabIndex === 1} onClick={(_e) => this.setState({ openTabIndex: 1 })}>
                  {t("displaysettings.columntabtext")}
                </DisplaySettingsTab>
                <DisplaySettingsTab isSelected={this.state.openTabIndex === 2} onClick={(_e) => this.setState({ openTabIndex: 2 })}>
                  {t("displaysettings.colortabtext")}
                </DisplaySettingsTab>
              </FlexItem>
              <FlexItem>{this.renderOpenTab()}</FlexItem>

              {/* Button area */}
              <FlexItem style={{ justifyContent: "space-between", marginTop: 20 }}>
                <FlexItem>
                  <SecondaryButton width={225} onClick={this.setDefaults}>
                    {t("displaysettings.resetdefaults")}
                  </SecondaryButton>
                </FlexItem>
                <FlexItem style={{ flex: 1 }}>
                  {this.state.error !== null ? (
                    <ErrorElem style={{ display: "flex", justifyContent: "flex-end", paddingRight: 20 }}>{this.state.error}</ErrorElem>
                  ) : null}
                </FlexItem>
                <FlexItem style={{ justifyContent: "space-between" }}>
                  <SecondaryButton width={136} onClick={this.cancel}>
                    {t("command.cancel")}
                  </SecondaryButton>
                  <GenericButton style={{ marginLeft: 20 }} width={136} onClick={this.apply}>
                    {t("command.ok")}
                  </GenericButton>
                </FlexItem>
              </FlexItem>
            </DisplaySettingsOuterContainer>
          </ModalContainer>
        </Draggable>
        <ModalBackdrop onClick={this.toggleSettingsVisibility}></ModalBackdrop>
      </div>
    );
  };
  render() {
    const { t } = this.props;
    return (
      <SettingsPanelContainerColumn>
        <SettingsPanelContainerRow>
          <FlexItem50>
            <IconSettingsButton50x50
              image={viewSettingsIcon}
              imageHover={viewSettingsIconHover}
              imagePressed={viewSettingsIconPressed}
              onClick={this.toggleSettingsVisibility}
            />
          </FlexItem50>
          <SettingsSpan>{t("pageheader.settings")}</SettingsSpan>
        </SettingsPanelContainerRow>
        {this.state.showDisplaySettings ? this.renderDisplaySettings() : ""}
      </SettingsPanelContainerColumn>
    );
  }
}

const mapState = (state: iRootState) => ({
  displaySettings: state.UI.displaySettings,
  objectTypeConfigurations: Array.from(state.common.configuration.objectTypeConfigurations.values()),
  getPropertyDefinition: (propertyId: number) => state.common.configuration.propertyDefinitions.get(propertyId),
  getObjectTypeProperties: (objectTypeId: number) => state.common.configuration.associatedPropertyDefinitionsOfObjectTypes.get(objectTypeId),
  getWorkflowStates: () => workflowStatesSelector(state as never),
});

const mapDispatch = (dispatch: Dispatch) => ({
  setDisplaySettings: (settings: DisplaySettings) => dispatch.UI.saveDisplaySettingsAsync(settings),
  updateTextFields: () => dispatch.items.updateTextFields(null),
});

export default withTranslation()(connect(mapState, mapDispatch)(DisplaySettingsEditor));

